import { Navbar } from "../components/Navbar";
import { ZoneMap } from "../components/ZoneMap";
import { Footer } from "../components/Footer";

export default function ServiceArea() {
  return (
    <main className="pt-16" data-testid="service-area-page">
      <Navbar />
      <ZoneMap />
      <Footer />
    </main>
  );
}
